module.exports = __webpack_public_path__ + "static/media/faq.393d2d8f.md";